import {
  DocumentsListBrokerageFirmModule,
  DocumentsUploadBrokerageFirmModule,
} from '@folio/modules';
import { useQuery } from '@tanstack/react-query';
import { configControllerGetPublicTenantConfigQueryOptions } from 'korint-sdk';

export function IntermediaryDetailsDocuments() {
  const { data: brokerageFirmDocumentsList = [] } = useQuery({
    ...configControllerGetPublicTenantConfigQueryOptions(),
    select: data => data.brokerageFirmDocuments?.brokerageFirmDocumentsList,
  });

  return (
    <>
      <DocumentsListBrokerageFirmModule
        documentsList={brokerageFirmDocumentsList}
        title="Documents"
      />

      <DocumentsUploadBrokerageFirmModule
        title="Documents à téléverser"
        documentsLists={[
          ...brokerageFirmDocumentsList
            .filter(
              ({ category }) =>
                category !== 'SEPA_MANDATE' &&
                category !== 'DISTRIBUTION_CONTRACT' &&
                category !== 'INSURANCE_CONTRACT' &&
                category !== 'IPID' &&
                category !== 'NOTICE',
            )
            .map(doc => ({ ...doc, required: false })),
          { category: 'beneficiary-change' },
        ]}
        showFraud
      />
    </>
  );
}
